import { useSearchParams } from 'react-router-dom';
import { useContext } from 'react';
import {
  LocalWidgetRouterContext,
  LocalWidgetRouterState,
} from '@/core/widgets/contexts/local-widget-router-context';

export default function useWidgetSearchParams() {
  const context = useContext<LocalWidgetRouterState>(LocalWidgetRouterContext);
  const [searchParams] = useSearchParams();

  if (context.useLocal) {
    const currentPath = context.path;
    const queryString = currentPath.includes('?') ? currentPath.split('?')[1] : '';

    if (queryString) {
      const tempParams = new URLSearchParams(queryString);
      return tempParams;
    }

    return new URLSearchParams();
  }

  return searchParams;
}
